var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tooltip",staticClass:"tooltip",class:{show: _vm.show, bottom: _vm.bottom}},[_vm._t("default"),_c('div',{ref:"tooltipArrow",staticClass:"tooltipArrow"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }